/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsParallelAvailableSlot } from "../../entities/models/ParallelAvailableSlot";
import { z } from "zod/v4";

export const modelsParallelAvailableSlotSchema = z.object({
    "child_barber_id": z.optional(z.int()),
"child_start_time": z.optional(z.string()),
"parent_barber_id": z.optional(z.int()),
"parent_start_time": z.optional(z.string()),
"time": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsParallelAvailableSlot>